import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Link, withRouter } from "react-router-dom";
import Loader from "../../Components/MainLayout/Loader";
import Header from "../../Components/MainLayout/Header";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class New extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Complaint: [],
      formData: {
        school: "",
        name: "",
        phone_no: "",
        complain: "",
      },
      subjects: [],
      classes: [],
      section: [],
      checkedsection: [],
      loading: false,
      alertMessage: false,
      sectionValidationMessage: "",
      type: "text",
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Complaint";
    this.fetchsubject();
    this.fetchclass();
    this.fetchsection();
  }

  handleClick = () => {
    this.setState({ loading: true });
  };

  fetchsubject = (params = {}) => {
    axios
      .get(`/api/cachedsubject`, {
        params: { ...params },
      })
      .then((res) => {
        this.setState({
          subjects: res.data,
        });
      });
  };

  fetchclass = (params = {}) => {
    axios
      .get(`/api/cachedclass`, {
        params: { ...params },
      })
      .then((res) => {
        this.setState({
          classes: res.data,
        });
      });
  };

  fetchsection = (params = {}) => {
    axios
      .get(`/api/cachedsection`, {
        params: { ...params },
      })
      .then((res) => {
        this.setState({
          section: res.data,
        });
      });
  };

  handleChange = (event) => {
    const { formData } = this.state;
    formData[event.target.name] = event.target.value;
    if (event.target.name === "for_class") {
      formData["subject"] = null;
    }

    this.setState({ formData });
  };

  handleSectionCheckbox = (event) => {
    var arr = this.state.checkedsection;
    if (this.state.checkedsection.includes(event.target.value)) {
    } else {
      arr.push(event.target.value);
    }
    this.setState({ checkedsection: arr, sectionValidationMessage: "" });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    // var
    let form_data = new FormData();
    const { formData } = this.state;
    this.setState({ loading: true });
    if (this.state.checkedsection.length > 0) {
      form_data.append("meeting_cordinator", this.props.user.user.id);
      form_data.append("school", this.props.user.user.school.id);
      form_data.append("meeting_name", formData.meeting_name);
      form_data.append("meeting_link", formData.meeting_link);
      form_data.append("meeting_datetime", formData.meeting_datetime);
      form_data.append("subject", formData.subject);
      form_data.append("for_class", formData.for_class);
      for (var i = 0; i < this.state.checkedsection.length; i++) {
        form_data.append("for_section", this.state.checkedsection[i]);
      }
      form_data.append("status", "true");
      axios
        .post(`/courseapi/onlineclassschedule`, form_data)
        .then((response) => {
          this.setState({ loading: false });
          this.props.history.push({ pathname: "/onlineclass" });
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else {
      this.setState({
        sectionValidationMessage: "Select Section",
        loading: false,
      });
    }
  };

  onFocus = () => {
    this.setState({
      type: "datetime-local",
    });
  };
  onBlur = () => {
    this.setState({
      type: "text",
    });
  };

  render() {
    const { staff, classes, subjects, section, formData } = this.state;
    console.log(this.state, "edjede");

    let unrestrictedRoles = ["IS_SUPERADMIN", "IS_PRINCIPAL", "IS_ACCOUNTANT"];

    let assignedClassSubject = JSON.parse(
      localStorage.getItem("assignedClassSubject")
    );

    let assignedClass = assignedClassSubject?.mapping_data?.map(
      (each) => each.assign_class_id
    );
    let assignedClassList = unrestrictedRoles?.includes(
      this.props.user.role.name
    )
      ? classes
      : classes?.filter((each) => assignedClass?.includes(each.id));

    if (
      formData["for_class"] &&
      assignedClassSubject?.mapping_data?.length > 0
    ) {
      var tempAssignedSubject = assignedClassSubject?.mapping_data?.filter(
        (each) => each.assign_class_id === JSON.parse(formData["for_class"])
      )[0]?.assign_subject;
      var assignedSubject =
        tempAssignedSubject?.length > 0 ? JSON.parse(tempAssignedSubject) : [];
    }

    let assignedSubjectList = unrestrictedRoles?.includes(
      this.props.user.role.name
    )
      ? subjects
      : subjects?.filter((each) => assignedSubject?.includes(each.id));

    const subjectvalue = assignedSubjectList?.map((item) => (
      <option key={item.id} value={item.id}>
        {item.subject}
      </option>
    ));
    const classvalue = assignedClassList?.map((item) => (
      <option key={item.id} value={item.id}>
        {item.class_name}
      </option>
    ));
    const sectiondata = section?.map((item) => (
      <div className="input-group in-line align-items-center pb-3">
        <input
          type="checkbox"
          onChange={this.handleSectionCheckbox}
          name="checkecollectfee"
          color="primary"
          value={item.id}
        />
        <div className="th-12 th-cap pl-2">{item.section_name}</div>
      </div>
    ));
    return (
      <div>
        <Header to="/home" title="Add Meeting" />

        <div className="container pt-3 col-12">
          <form onSubmit={this.handleSubmit} autoComplete="off">
            <div className="input-group mb-3 input-group shadow-sm">
              <input
                className="form-control th-input-primary"
                placeholder="Meeting Name"
                name="meeting_name"
                value={formData.meeting_name}
                onChange={this.handleChange}
                required
              />
            </div>
            <div className="input-group my-3 input-group shadow-sm">
              <input
                className="form-control th-input-primary"
                placeholder="Meeting Link"
                name="meeting_link"
                value={formData.meeting_link}
                onChange={this.handleChange}
                required
              />
            </div>
            <div className="input-group my-3 input-group shadow-sm">
              <input
                className="form-control th-input-primary"
                placeholder="Meeting Date Time"
                name="meeting_datetime"
                type={this.state.type}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                value={formData.meeting_datetime}
                onChange={this.handleChange}
                required
              />
            </div>

            <div className="input-group my-3 input-group shadow-sm">
              <select
                className="form-control th-input-primary w-100"
                placeholder="Class"
                name="for_class"
                value={formData.for_class}
                onChange={this.handleChange}
                required
              >
                <option value="" selected>
                  Select Class
                </option>
                {classvalue}
              </select>
            </div>
            <div className="input-group my-3 input-group shadow-sm">
              <select
                className="form-control th-input-primary w-100"
                placeholder="Subject"
                name="subject"
                value={formData.subject}
                onChange={this.handleChange}
                required
              >
                <option value="" selected>
                  Select Subject
                </option>
                {subjectvalue}
              </select>
            </div>
            <div className="col-6">
              <div className="th-14 th-medium th-black mt-3 mb-2">Section:</div>
              {sectiondata}
            </div>
            <div className="d-flex justify-content-end py-3">
              {this.state.loading ? (
                <div className="my-1 pr-2">
                  <Loader />
                </div>
              ) : null}
              <button
                // onClick={this.handleClick}
                type="submit"
                className="th-btn-primary px-4 py-2"
              >
                SUBMIT
              </button>
            </div>
          </form>
          <p className="text-center col-12">
            {this.state.sectionValidationMessage}
          </p>
        </div>
      </div>
    );
  }
}
export default withRouter(connect(mapStateToProps)(New));
